import delinkUserDetails from './delinkUserDetails';

export default delinkUserDetails;
